import { Outlet, useParams } from "react-router-dom";
import { CartProvider } from "../state/cartStore";
import { useReservationStateSync } from "../hooks/useReservationStateSync";

/**
 * Layout for the whole /book/:facilityId booking flow.
 *
 * The ONE CartProvider is LIFTED here so a single cart store is shared across the
 * court sheet, the review/checkout screen, and the confirmation — the slots a
 * player picks on the sheet survive the navigation to /review. A provider scoped
 * to the sheet page (the 3a shape) would leave the review screen with an empty
 * cart, which is the bug this lift fixes.
 *
 * Pure structure — no chrome of its own (the AppShell already provides it). Just
 * the cart context + an <Outlet> for the nested routes.
 */
export function BookingLayout() {
  const { facilityId } = useParams<{ facilityId: string }>();
  useReservationStateSync(facilityId);

  return (
    <CartProvider>
      <Outlet />
    </CartProvider>
  );
}
